export function getElementDescription(element: any, language: any) {
  return (
    (
      element.translations &&
      element.translations[language] &&
      element.translations[language].description
    ) ||
    element.options.description
  );
}
